import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import ConfirmEmailPage from 'apps/auth/pages/email/ConfirmEmailPage';

const authEmail = [
    {
        path: '/auth/email/confirm/preview',
        component: ConfirmEmailPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/email/check/inbox/preview',
        component: ConfirmEmailPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
];

export default authEmail;
